import { useEffect } from "react";

export default () => {
  useEffect(() => {
    window.ReactNativeWebView.postMessage(JSON.stringify({ twoFactorSuccess: true }));
  }, []);

  return <div style={{ flex: 1, width: "100%", height: "100%" }}></div>;
};
